export const usCategories = [
  { slug: 'bankruptcy', name: 'Bankruptcy' },
  { slug: 'business', name: 'Business' },
  { slug: 'business-formation', name: 'Business Formation' },
  { slug: 'corporation', name: 'Corporation' },
  { slug: 'estate-planning', name: 'Estate Planning' },
  { slug: 'health-care', name: 'Health Care' },
  { slug: 'human-resources', name: 'Human Resources' },
  { slug: 'landlord-and-tenant', name: 'Landlord and Tenant' },
  { slug: 'llc', name: 'LLC' },
  { slug: 'marriage-and-divorce', name: 'Marriage and Divorce' },
  { slug: 'nonprofit', name: 'Nonprofit' },
  { slug: 'partnership', name: 'Partnership' },
  { slug: 'personal-affairs', name: 'Personal Affairs' },
  { slug: 'property', name: 'Property' },
  { slug: 'billing-faqs', name: 'General and Billing FAQs' }
]
